import React from 'react'
import TopBreadcrumb from 'components/TopBreadCrumb'
import MainPage from '../../Cockpit/MainPageV2'

const Page = () => {
  const breadcrumbList = [{ name: '看板' }, { name: '操作看板' }, { name: '对标' }]
  return (
    <div
      style={{ height: '100%', display: 'flex', flexDirection: 'column', padding: '0 24px 24px' }}
    >
      <TopBreadcrumb breadcrumbList={breadcrumbList} />
      <MainPage paddingStyle={{ padding: 0 }} tabsStyle={{ top: -7 }} />
    </div>
  )
}

export default Page
